import { requireElement } from "./Hud";

/**
 * Placa do jardim ("info"): titulo e texto vindos do mapa. Linhas em branco
 * separam paragrafos. Resolve quando o jogador fecha.
 */
export function showInfo(title: string, text: string): Promise<void> {
  return new Promise((resolve) => {
    const root = requireElement<HTMLDivElement>("overlay-root");
    const overlay = document.createElement("div");
    overlay.className = "overlay";

    const panel = document.createElement("div");
    panel.className = "panel info-panel";
    const h1 = document.createElement("h1");
    h1.textContent = title;
    panel.append(h1);
    for (const paragraph of text.split(/\n\s*\n/)) {
      const p = document.createElement("p");
      p.className = "sub";
      p.textContent = paragraph.trim();
      panel.append(p);
    }
    const button = document.createElement("button");
    button.type = "button";
    button.className = "primary";
    button.textContent = "Voltar";
    panel.append(button);
    overlay.append(panel);
    root.replaceChildren(overlay);

    const close = () => {
      document.removeEventListener("keydown", onKey);
      root.replaceChildren();
      resolve();
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape" || event.key === "Enter") {
        event.preventDefault();
        close();
      }
    };
    button.addEventListener("click", close);
    document.addEventListener("keydown", onKey);
    button.focus();
  });
}
